module.exports = __webpack_public_path__ + "fonts/impact.393c8a0.ttf";